import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { priceToY } from "src/app/Models/Annotations/Annotations";
import { Chart } from "src/app/Models/Chart";
import { PriceMark } from "src/app/Models/lcharts/src/model/price-scale";
import { CountsData, DgHubClientService, SimbleBidAsk } from "../dg-hub-client.service";
import { DGDrawingServiceGlobal } from "../DrawingService";
import { SignalService } from "../SignalService/SignalService";
import { ResizeService } from "../ResizeService.service";
import { TrackedStrikesService } from "../TrackedStrikes/TrackedStrikes.service";


@Injectable({
  providedIn: "root",
})

export class StrikesSumService {

  public priceScaleWidth = 300;
  public barsWidth: 10;
  public lcanvasLeft: number;
  public lcanvasTop: number;
  public chart: Chart;

  public strikes: Map<number, Map<string, CountsData>> = new Map<number, Map<string, CountsData>>();
  public simpleBidAsks: Map<string, SimbleBidAsk> = new Map<string, SimbleBidAsk>()

  constructor(
    private _hubservice: DgHubClientService, private signalService: SignalService, private toastr: ToastrService, private resizeService: ResizeService, private trackedStrikesService:TrackedStrikesService) {
    DGStrikeSumServiceGlobal._init(this);

    //var rightBarState = DGDrawingServiceGlobal.drawingService().settingsService.getRightBarState();
    this._hubservice.StrikeSumAllTick.subscribe((l) => {
      // var t=JSON.stringify(l);
      //    //console.log("JSONSTRIKES", t);
      l.forEach((item) => {
        this.update(item);
      })
      this.newStrikes(this.lastMarks)
    })



    this._hubservice.ResetStrikes.subscribe((l) => {
      this.strikes.clear();
      this.newStrikes(this.lastMarks);
      this.signalService.lastSignalsNotifications = [];
    })

    this._hubservice.SignalTick.subscribe((l) => {
      this.signalService.checkStrikesSum(l);
    })

    this._hubservice.StrikeSumSingleTick.subscribe((l) => {
      this.update(l);

    })

    this._hubservice.StrikeTick.subscribe((r) => {
      // var getSymbol = this.simpleBidAsks.get(r.symbol);
      // if(getSymbol)
      // {
      r.forEach((k) => {
        this.simpleBidAsks.set(k.symbol, k);
      })

      // }
    })

  }

  public getSymbolDataValue(symbol: string) {
    var symbolData = this.simpleBidAsks.get(symbol);
    if (symbolData) {
      jQuery(`Price_${symbolData.symbol.replace(" ", "_")}`).text(
        `${symbolData.bid.toFixed(2)}`
      );
      return symbolData.bid.toFixed(2)
    }
    return '&nbsp;'
  }


  public update(item: CountsData) {
    var strike = this.strikes.get(item.strike);

    if (strike) {
      var z = strike.get(item.symbol);

      if (z) {
        strike.set(item.symbol, item)
      }
      else {
        //   var t = new Map<string,CountsData>();
        strike.set(item.symbol, item);
        //    this.strikes.set(item.strike,t)
      }
    }
    else {
      var t = new Map<string, CountsData>();
      t.set(item.symbol, item);
      this.strikes.set(item.strike, t)
    }
  }



  public displaySymbols: boolean = false;



  public updateCanvasLocation() {
    this.lcanvasLeft =
      $("#ist_price_canvas_0")[0].getBoundingClientRect().left +
      $(window)["scrollLeft"]();

    this.lcanvasTop =
      $("#ist_price_canvas_0")[0].getBoundingClientRect().top +
      $(window)["scrollLeft"]();
  }

  public lastMarks: PriceMark[] = [];

  private _rightBarsEnabled: boolean = true;
  public get rightBarsEnabled(): boolean {
    return this._rightBarsEnabled;
  }
  public set rightBarsEnabled(value: boolean) {
    this._rightBarsEnabled = value;
    var width = window.innerWidth - 10;
    let diff = (DGDrawingServiceGlobal.drawingService().dataService.systemVersion == "iOS") ? 60 : 20;
    var height = window.innerHeight - diff;

    this.resizeService.resizeAction(width, height);
    if (value == false) {
      jQuery(".strike-strike-sum-wrapper").remove();
      jQuery(".IST_customMarkup").remove();
      jQuery(".IST_firstBar").remove();
      jQuery(".IST_firstBarData").remove();
    }

    DGDrawingServiceGlobal.drawingService().settingsService.setRightBarState(value);

  }

  public newStrikes(marks: PriceMark[]) {

    if (!this.rightBarsEnabled) {
      return;
    }
    //   return;



    this.lastMarks = marks;
    if (!this.chart) {
      return;
    }
    this.updateCanvasLocation();


    // //console.log("newStrikes marks",marks);

    jQuery(".strike-strike-sum-wrapper").remove();
    jQuery(".IST_customMarkup").remove();
    jQuery(".IST_firstBar").remove();
    jQuery(".IST_firstBarData").remove();
    var activeHeight = 40;

    var locFirst = null;
    var locSecond = null;
    for (var t = 0; t < marks.length; t++) {
      var strike = Number(marks[t].label.split(".")[0]);
      var strikeLevelData = this.strikes.get(strike);
      if (marks.length >= 2 && strikeLevelData) {
        if (!locFirst) {
          locFirst = priceToY(Number(marks[t].label), this.chart.chart);
        }
        else {
          if (!locSecond) {
            locSecond = priceToY(Number(marks[t].label), this.chart.chart);
          }
        }


      }
    }

    if (locFirst && locSecond) {
      activeHeight = locSecond - locFirst;
    }
    var addedStrikes = []
    marks.forEach((l) => {


      var id = `strikes_sum${l.label.replace(".", "_")}`;
      var strike = Number(l.label.split(".")[0]);
      var strikeLevelData = this.strikes.get(strike);
      let y = priceToY(Number(l.label), this.chart.chart);
      if (strike % 5 == 0 && strikeLevelData) {
        if (addedStrikes.includes(strike)) {
          return;
        }
        addedStrikes.push(strike);
        var blinkCLassC = "";
        var blinkCLassP = "";


        var callDiv = `<div style="width:50%;color:green;display:inline-block"></div>`
        var putDiv = `<div style="width:50%;color:red;display:inline-block"></div>`

        var callPriceDiv = `<div style="width:50%;color:green;display:inline-block"></div>`
        var putPriceDiv = `<div style="width:50%;color:red;display:inline-block"></div>`

        for (let [key, value] of strikeLevelData) {

          if (key.includes(" C")) {

            callDiv = `<div class='CTN_${key.replace(" ", "_")}' style="width:100%;color:green;display:inline-block">
                              <div style="width:100%;display:flex;position: relative;">
                                  <div class="green-txt cpDIvs" style="width:100%;font-size:12px;"><span class='cinternalblink ${key.replace(" ", "_")}'>${value.lastSize}</span>/${value.firstSum}-${value.secondSum}</div>
                              </div>
                          </div>`;

            if (this.signalService.blinks.get(key)) {
              blinkCLassC = "blinkC"
            }

            callPriceDiv = `<div class='Price_${key.replace(" ", "_")}'>${this.getSymbolDataValue(key)}</div>`
          }

          if (key.includes(" P")) {

            putDiv = `<div class='CTN_${key.replace(" ", "_")}' style="width:100%;color:red;display:inline-block">
                <div style="width:100%;display:flex;position: relative;">
                    <div class="red-txt cpDIvs"><span class='pinternalblink ${key.replace(" ", "_")}'>${value.lastSize}</span>/${value.firstSum}-${value.secondSum}</div>
                </div>
              </div>`;


            if (this.signalService.blinks.get(key)) {
              blinkCLassP = "blinkP"
            }

            putPriceDiv = `<div class='Price_${key.replace(" ", "_")}'>${this.getSymbolDataValue(key)}</div>`
          }

        }


        //       //console.log("PUT",putDiv,"CALL",callDiv);
        var borderColor = "#2b2b43"
        var borderColorTop = "rgba(255,255,255,0.2)"
        var style = `background-color:transparent;
         pointer-events:none;
         top: ${y + this.lcanvasTop}px;
         left: ${this.lcanvasLeft + 5}px;
         width:${this.priceScaleWidth + 10 - this.barsWidth}px;
         height:${activeHeight + 1}px;
         font-size:12px;
         position:absolute;
         border-top:1px solid ${borderColorTop};
         border-bottom:1px solid ${borderColor};
         border-right:1px solid ${borderColor};
         margin-left:-3px;
         margin-right:-3px;
         display:block`

        var innerRowSTyle = `
                              border-bottom:1px solid ${borderColor};
                              height:${activeHeight < 50 ? 0.5 * activeHeight : 22}px;
                              width:100%;
                              text-align:center;
          `
        var innerRowBottom = `
           height:${activeHeight < 50 ? 0.5 * activeHeight : 22}px;
           width:100%;
           text-align:center;
        
           `
        var fillRowBottom = `
           height:${activeHeight - (activeHeight < 50 ? 0.5 * activeHeight : 22)}px;
           width:100%;
           text-align:center;

           `

        var t = "";
        let ex = l.label.split(".");
        let textX = `${t}${ex[0].substr(ex[0].length - 2)}.${ex[1].substr(0, 1)}`;
        //  var finall =   `<div id="${id}" style="${style}" class='strike-strike-sum-wrapper ${blinkCLassP}  ${blinkCLassC}'>
        //                   ${callDiv}
        //                   ${putDiv}
        //               </div>`
        var finall = `<div id="${id}" style="${style}" class='strike-strike-sum-wrapper ${blinkCLassP}  ${blinkCLassC}'>
                          <div style="${innerRowSTyle}">
                            <div style="display:inline-block;height:100%;width:85px;white-space:nowrap;border-right:1px solid ${borderColor}">${callDiv}</div>
                            <div style="display:inline-block;width:30px"></div>
                            <div style="display:inline-block;;height:100%;width:85px;white-space:nowrap;border-left:1px solid ${borderColor}">${putDiv}</div>
                          </div>
                          <div style="${innerRowBottom}">
                            <div style="color:#fff;display:inline-block;height:100%;width:85px;white-space:nowrap;border-right:1px solid ${borderColor}">${callPriceDiv}</div>
                            <div style="display:inline-block;width:30px;color:#fff">${textX}</div>
                            <div style="color:#fff;display:inline-block;;height:100%;width:85px;white-space:nowrap;border-left:1px solid ${borderColor}">${putPriceDiv}</div>
                          </div>
                          <div style="${fillRowBottom}">
                            <div style="display:inline-block;height:100%;width:85px;white-space:nowrap;border-right:1px solid ${borderColor}">&nbsp;</div>
                            <div style="display:inline-block;width:30px;color:#fff"></div>
                            <div style="display:inline-block;;height:100%;width:85px;white-space:nowrap;border-left:1px solid ${borderColor}">&nbsp;</div>
                          </div>
                        </div>`

        jQuery("body").append(
          `${finall}`
        );

        
        var markColor = 'white';

        var includesStrike = this.trackedStrikesService.hasStrike(this.trackedStrikesService.extractStrike(id));
        // console.log("includesStrike",this.trackedStrikesService.extractStrike(id),includesStrike)
        // console.log("includesStrike",this.trackedStrikesService.extractStrike(id),includesStrike)
        if(includesStrike==true)
        {
          markColor="#FFDE21";
        }
        var styleCustomMarkup = `background-color:transparent;
        color: ${markColor};
        pointer-events:_none;
        user-select: none;
        font-family:arial;
        top: ${y + this.lcanvasTop - 8}px;
        left: ${this.lcanvasLeft - 45}px;
        width:30px;
        height:20px;
        font-size:12px;
        position:absolute;z-index:10000000`
        var t = "";
        let ex1 = l.label.split(".");
        let textX1 = l.label;//`${t}${ex1[0].substr(ex[0].length - 2)}.${ex1[1].substr(0, 1)}`;
        let customMark = `<div style="${styleCustomMarkup}" data-id="${id}" class='IST_customMarkup'>${textX1}</div>`;
        jQuery("body").append(
          `${customMark}`
        );

        jQuery('.IST_customMarkup').off('click').on('click', (event) => {
          const target = event.currentTarget;
          const id = jQuery(target).data('id');

          this.trackedStrikesService.UpdateSingleTrackedStrike(id);
        });

      }
      else {

        // var styleCustomMarkup = `background-color:transparent;
        // color:white;
        // pointer-events:none;
        // font-family:arial;
        // top: ${y + this.lcanvasTop - 8}px;
        // left: ${this.lcanvasLeft - 30}px;
        // width:30px;
        // height:20px;
        // font-size:12px;
        // position:absolute;`
        // var t = "";
        // let ex = l.label.split(".");
        // let textX = `${t}${ex[0].substr(ex[0].length - 2)}.${ex[1].substr(0, 1)}`;
        // let customMark = `<div style="${styleCustomMarkup}" class='IST_customMarkup'>${textX}</div>`;
        // jQuery("body").append(
        //   `${customMark}`
        // );
      }
    });


    var lstPrice = DGDrawingServiceGlobal.drawingService().mainLastPrice;
    var price = this.nearestStrikeValue(lstPrice, 5);

    var _percentheight = priceToY(price, this.chart.chart) - priceToY(price + 1, this.chart.chart);



    this.renderBar(price, _percentheight, "thirdSum", 95);
    this.renderBar(price, _percentheight, "lastSize", 85);
    this.renderBar(price, _percentheight, "firstSum", 75);
    this.renderBar(price, _percentheight, "secondSum", 65);

    this.renderBar(price, _percentheight, "notification", 45);
    this.renderBar(price, _percentheight, "thirdSum_cash", 35);
    this.renderBar(price, _percentheight, "firstSum_cash", 25);
    this.renderBar(price, _percentheight, "secondSum_cash", 15);

  }


  public renderBar(price, _percentheight, bar, rightlocation) {
    var currentPercent = this.computePercent(price, bar);

    if (currentPercent == null) {
      return;
    }

    var currentBarHeight = 0.5 * Math.abs(currentPercent) * _percentheight;

    let baseLevel = priceToY(price, this.chart.chart);
    let top = `${baseLevel + this.lcanvasTop - currentBarHeight}`;

    if (currentPercent < 0) {
      top = `${baseLevel + this.lcanvasTop}`;
    }
    var backgroundColor = `#00ff00`;

    if (!bar.includes("cash")) {
      if (bar == "thirdSum" || bar == "notification") {
        backgroundColor = "#00ffff";
      }

      if (currentPercent < 0) {
        backgroundColor = `#ff0000`;

        if (bar == "thirdSum" || bar == "notification") {
          backgroundColor = "#ff00ff";
        }
      }
    }
    else {
      backgroundColor = "#ffff00";
      if (currentPercent < 0) {
        backgroundColor = "#ff9900";
      }
    }


    var firstBarStyle = `
    right: ${rightlocation}px;
    top: ${top}px;
    width:6px;
    height:${currentBarHeight}px;
    background-color:${backgroundColor};
    position:absolute;
    `
    let firstBOox = `<div style="${firstBarStyle}" class='IST_firstBar'> </div>`;
    jQuery("body").append(
      `${firstBOox}`
    );


    // //console.log(baseLevel);
  }




















  public firstBarData = ""

  public paercentHeightRatio = 0.25
  public computePercent(basePrice: number, bar: string) {
    if (bar == "notification") {
      return this.paercentHeightRatio * this.signalService.computePutCallRatio();
    }

    this.firstBarData = ``
    var strikes = this.strikes;
    var topStrikeLevelCall = basePrice + 5 * 5;
    var bottomStrikeLevelCall = basePrice - 2 * 5;

    var callSum = 0;
    var putSum = 0;

    for (var i = bottomStrikeLevelCall; i <= topStrikeLevelCall; i = i + 5) {
      callSum += this.getValStrike(i, " C", bar);
    }

    var topStrikePut = basePrice + 2 * 5;
    var bottomLevelPut = basePrice - 5 * 5;

    for (var i = bottomLevelPut; i <= topStrikePut; i = i + 5) {
      putSum += this.getValStrike(i, " P", bar);
    }


    var diff = callSum - putSum;
    var base = Math.min(callSum, putSum);

    if (bar.includes("cash")) {
      var percentResult = 100 * (diff / base)
      return this.paercentHeightRatio * percentResult;
    }

    if (base > 0) {
      var percentResult = 100 * (diff / base)
      return this.paercentHeightRatio * percentResult;
    }

    return null;
  }




  public getValStrike(strike: number, type: string, bar: string) {
    var sum = 0;
    var striked = this.strikes.get(strike);
    if (striked) {
      var key = Array.from(striked.keys()).find(key => key.includes(type));
      var inner = striked.get(key);

      if (inner) {
        if (bar == "lastSize") {
          return inner.lastSize;
        }

        if (bar == "firstSum") {
          return inner.firstSum;
        }

        if (bar == "secondSum") {
          return inner.secondSum;
        }

        if (bar == "thirdSum") {
          return inner.thirdSum;
        }

        if (bar == "thirdSum_cash") {
          return inner.thirdSumCash;
        }

        if (bar == "secondSum_cash") {
          return inner.secondSumCash;
        }

        if (bar == "firstSum_cash") {
          return inner.firstSumCash;
        }

      }
    }
    return 0;
  }












  public nearestStrikeValue(value: number, granulity: number) {
    var remainder = value % granulity;
    var nearestMultiple;

    if (remainder >= (granulity / 2)) {
      nearestMultiple = (value + granulity - remainder);
    }
    else {
      nearestMultiple = (value - remainder);
    }


    return nearestMultiple;
  }
}

export class DGStrikeSumServiceGlobal {
  private static _service: StrikesSumService;
  static _init(service: StrikesSumService) {
    DGStrikeSumServiceGlobal._service = service;
  }

  static strikeService(): StrikesSumService {
    return DGStrikeSumServiceGlobal._service;
  }
}
